import React from "react";
import "../../css/toastView.css";
import Heading from "../../components/Heading";
import ContentPage from "../../components/content-page";
import Meta from "../../components/meta";
import PropTypes from "prop-types";
import ReactPixel from "react-facebook-pixel";
import Link from "gatsby-link";
import Modal from "../../components/Modal";
import Slider from "react-slick";
import "../../components/slick.css";
import "../../components/slick-theme.css";
import LinkedInTag from "react-linkedin-insight";

;
const icon2 = "https://winpeforum.com/assets/elements/DaivikRaval.png";
const icon3 = "https://winpeforum.com/assets/elements/PratitiDasgupta.png";
const icon4 = "https://winpeforum.com/assets/MsParitaAshar.png";
 
 

let duration = 400;

const TeamModal = ({ activeItem, show, onHide }) => {
  return (
    <Modal
      direction=""
      className="teamdetails__wrapper"
      show={show}
      onHide={onHide}
    >
      <Modal.Header>
        <div className="head_section">
          <span className="item_name">{activeItem.name}</span>
          <div
            className="item_des"
            dangerouslySetInnerHTML={{ __html: activeItem.post }}
          ></div>
        </div>
        <span className="cross pull-right">
          <i onClick={onHide} className="fa fa-times" />
        </span>
      </Modal.Header>
      <Modal.Body>
        <div className="item__desc">
          <div dangerouslySetInnerHTML={{ __html: activeItem.desc }}></div>
        </div>
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  );
};

TeamModal.propTypes = {
  activeItem: PropTypes.object,
  show: PropTypes.object,
  onHide: PropTypes.object,
};

export class SheShines extends React.Component {
  constructor(args) {
    super(args);
    this.state = {
      slidesToShow: 1,
      activeItem: {},
      isShow: false,
      defaultStyle: {
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 0,
      },
    };
    this.Speaker2 = [
     
  
  
        {
          imgUrl: icon3,
          desc: `<div>
Pratiti is an infrastructure and private markets finance professional with experience spanning project finance, capital raising, and investment analysis across renewables, digital infrastructure, and private credit in India, Southeast Asia, and Europe. A Winpe Ambassador , she has been a part of the community since 2021 and is highly passionate about spearheading the cause of diversity in alternative investments.






 
          </div>`,
          name: "Pratiti Dasgupta ",
          post: `<div> 






          </div>`,
        },
  ];
    this.Speaker1 = [
       
        {
          imgUrl: icon4,
          desc: `<div>
Parita Ashar, CFA, is a Principal with OIJIF and has been with the Firm since 2017. She has more than 14 years of experience across Private Equity Investing and Equity Research. She manages OIJIF’s Investments in Annapurna Finance, Capital Small Finance Bank, PNB MetLife and HomeLane and has full cycle experience from investments to exits. She was involved in delivering successful IPO of Capital Small Finance Bank and secondary exits in Annapurna Finance and PNB MetLife.
<br/><br/>

Prior to joining OIJIF, she has worked at the research desk of the institutional equities division of Ambit Capital. She was responsible for leading research on key listed companies in the sectors of cement, metals and mining and aviation and has also covered telecom and media sectors in the past. Her research and recommendations have been based on long term competitive advantages of companies, with strong focus on accounting and corporate governance practices of companies. Parita is a Chartered Accountant and a CFA Charter Holder.
 
          </div>`,
          name: "Parita Ashar",
          post: `<div>Principal <br/>
OIJIF






          </div>`,
        },
         
       
    ];
 
  
  }
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    ReactPixel.init("2879175222167037");
    ReactPixel.track("ViewContent", location);
    LinkedInTag.init("2117884");
    LinkedInTag.track("2310748");
    setTimeout(() => {
      this.setState({
        defaultStyle: {
          transition: `opacity ${duration}ms ease-in-out`,
          opacity: 1,
        },
      });
    }, 500);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    const { slidesToShow } = this.state;
    // // console.log("width", window.innerWidth)
    if (window.innerWidth <= 768 && window.innerWidth > 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else if (window.innerWidth <= 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    }
  };
  togglePopUp = (item) => {
    this.setState({
      isShow: !this.state.isShow,
      activeItem: item || {},
    });
  };
  render() {
    const { defaultStyle, isShow, slidesToShow } = this.state;
    const { location } = this.props;
    let settings = {
      dots: false,
      infinite: true,
      speed: 6000,
      autoplay: true,
      slidesToShow: slidesToShow,
      slidesToScroll: slidesToShow,
      autoplaySpeed: 7000,
      arrows: true,
    };
    console.log("render", this.render1, slidesToShow);
    this.render1 = this.render1 + 1;
    return (
      <ContentPage>
        <Meta
          title="Winpe Ignite: Workshop on Financial Modelling for Investment Decisions"
          image={"https://winpeforum.com/api/src/templates/emailers/assets/newsletter2022.png"}
          description="On 1st August 2026, Winpe hosted an Ignite workshop on how financial models turn a founder's vision into testable, investable numbers. Featuring Parita Ashar (Principal, OJIF), moderated by Pratiti Dasgupta, the session explored how investors build, stress-test, and use financial models to underwrite real deals. Click here to view the recorded workshop."
          location={location}
        />
        <div className="section__content" style={defaultStyle}>
          <div className="toastshine_wrapper">
            <div className="back_event">
              <Link to="/events/">
                <i className="fa fa-arrow-left"> Back to Events</i>
              </Link>
            </div>
            <div className="toastshine_section">
              <div className="m_heading">Winpe Ignite: Workshop on Financial Modelling for Investment Decisions </div>
              <div className="r_btm"></div>
               
 
              <div className="date_heading">
                <div className="date_heading">
                  <span>August 1, 2026</span>
                  <br/>
                  <span> <i>Online</i></span>
                </div>
              </div>
              <br/>

 
              <div className="top_text" style={{textAlign: 'justify'}}> 
      On 1st August 2026, Winpe hosted an Ignite workshop on how financial models turn a founder's vision into testable, investable numbers. Featuring  <a style={{color:'blue'}} href="https://www.linkedin.com/in/parita-ashar-cfa-28a9b23b?utm_source=share_via&utm_content=profile&utm_medium=member_android" >Parita Ashar</a> (Principal, OJIF), moderated by <a  style={{color:'blue'}}  href="https://www.linkedin.com/in/pratiti-dasgupta-bb92671b1/">Pratiti Dasgupta</a>, the session explored how investors build, stress-test, and use financial models to underwrite real deals. Click <a  style={{color:'blue'}}  href="https://youtu.be/g4UtdA1jF5Y">here</a> to view the recorded workshop.
 <br/><br/>
A live poll kicked off the workshop: given two founders pitching the same coffee-chain opportunity, the room overwhelmingly backed the one who spoke in numbers over the one who spoke in vision, <b>even though neither pitch actually proved which business was better</b>. Parita used this to frame the whole session: conviction needs a model behind it, not just a story.



<h4><b>Key Segments Discussed: </b></h4>
 
<p><b>Financial Models: A Tool for Better Decision-Making</b><br/> Financial models translate business assumptions into measurable outcomes, enabling both founders and investors to evaluate opportunities with greater clarity.
</p> 
<ul>
<li>For founders, financial models help plan growth, anticipate capital requirements, and prepare for future business scenarios.
</li>
<li>For investors, they provide a structured framework to evaluate expected returns, compare opportunities, and assess investment risks.</li>
</ul>

<p><b>Building Blocks of a Financial Model</b><br/>
Using a coffee chain case study, the session demonstrated how investors break down business performance into measurable drivers instead of relying on high-level projections.
</p> 
<ul>
<li>Revenue drivers such as customer footfall, pricing, and store expansion, alongside cost structures, operating leverage, and margin assumptions.
</li>
<li>Cash flow planning and capital requirements as key indicators of business sustainability.</li>
</ul>

<p><b>Scenario Analysis & Investment Evaluation</b><br/>
Rather than relying on a single forecast, participants explored how investors stress-test assumptions and evaluate a range of possible outcomes.

</p> 
<ul>
<li>Understanding base, downside, and upside scenarios through sensitivity analysis to assess investment risk and expected returns.
</li>
<li>Comparing different investment opportunities through risk-return trade-offs rather than headline metrics.
</li>
</ul>


<br/> 
 <h4><b>Key Takeaways</b></h4>
 <ul>
    <li>Financial models are decision-making tools, not just spreadsheets.</li>
    <li>Strong investment decisions begin with testing assumptions and understanding the range of possible outcomes, not accepting a single projection at face value.</li>
    <li>Cash generation and risk-return trade-offs matter as much as profitability when evaluating a business.
</li>
 </ul>



<br/> 
<h4><b>Tools & Platforms Mentioned</b></h4>
 <ul style={{columnCount:3, columnGap:'20px'}}>
<li>Two-Variable Data Tables (Excel)</li>
<li>Scenario & Sensitivity Analysis</li>
<li>EV/EBITDA Multiple Analysis</li>
<li>Revenue Build-Up Modelling</li>
<li>Cash Conversion Cycle</li>
<li>COCO vs. FOCO (ROIC) Analysis</li>
 </ul>

<br/> 
 <p><b><i>Financial models do not predict the future—they help investors understand how changes in assumptions influence risk, expected returns, and ultimately, investment decisions.</i></b>

</p>
 
 


              </div>
              <br />

              
           
<br/>  

<div class="row">
  <div class="col-md-2">&nbsp;</div>
<div class="col-md-4"> 
              <h2 class="ignite-ask-me-anything__heading" style={{ fontSize: "30px" }}>Facilitator</h2>          <div class="r_btm"></div>
                      
                 
                      <div className="Our_Speakers container">
                        <center>
                          <div className="Speakers_img" style={{ width: '60%' }}>
                          <div className="row">

{this.Speaker1.map((item, i) => {
 if(i<=12) 
 {
  return (
    <div
      className="main_speaker_card col-md-12 col-sm-12 col-lg-12"
      key={i}
    >
      <div className="Scardd">
        <div
          className="s_img"
          onClick={() => this.togglePopUp(item)}
        >
           <center>  <img
            src={item.imgUrl}
            alt={item.name}
            className="img-responsive"
            style={{ borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }}
          />
          </center>
        </div>
        <br />    <div
          className="Speakers_name"
          dangerouslySetInnerHTML={{ __html: item.name }}
        ></div>
        <div
          className="Speakers_post"
          dangerouslySetInnerHTML={{ __html: item.post }}
        ></div>
      </div>
    </div>
  );
 }
 else 
 return (
    <div
      className="main_speaker_card col-md-6 col-sm-12 col-lg-6"
      key={i}
    >
      <div className="Scardd">
        <div
          className="s_img"
          onClick={() => this.togglePopUp(item)}
        >
           <center>  <img
            src={item.imgUrl}
            alt={item.name}
            className="img-responsive"
            style={{ borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }}
          />
          </center>
        </div>
        <br />    <div
          className="Speakers_name"
          dangerouslySetInnerHTML={{ __html: item.name }}
        ></div>
        <div
          className="Speakers_post"
          dangerouslySetInnerHTML={{ __html: item.post }}
        ></div>
      </div>
    </div>
  );
})}
</div>
                          </div>

                        </center>
                      </div>
                 </div>   
                 
        
 
 
  
<div class="col-md-4"> 
              <h2 class="ignite-ask-me-anything__heading" style={{ fontSize: "30px" }}>Moderator</h2>          <div class="r_btm"></div>
                      
                 
                      <div className="Our_Speakers container">
                        <center>
                          <div className="Speakers_img" style={{ width: '50%' }}>
                          <div className="row">

{this.Speaker2.map((item, i) => {
 if(i<=12) 
 {
  return (
    <div
      className="main_speaker_card col-md-12 col-sm-12 col-lg-12"
      key={i}
    >
      <div className="Scardd">
        <div
          className="s_img"
          onClick={() => this.togglePopUp(item)}
        >
           <center>  <img
            src={item.imgUrl}
            alt={item.name}
            className="img-responsive"
            style={{ borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }}
          />
          </center>
        </div>
        <br />    <div
          className="Speakers_name"
          dangerouslySetInnerHTML={{ __html: item.name }}
        ></div>
        <div
          className="Speakers_post"
          dangerouslySetInnerHTML={{ __html: item.post }}
        ></div>
      </div>
    </div>
  );
 }
 else 
 return (
    <div
      className="main_speaker_card col-md-6 col-sm-12 col-lg-6"
      key={i}
    >
      <div className="Scardd">
        <div
          className="s_img"
          onClick={() => this.togglePopUp(item)}
        >
           <center>  <img
            src={item.imgUrl}
            alt={item.name}
            className="img-responsive"
            style={{ borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }}
          />
          </center>
        </div>
        <br />    <div
          className="Speakers_name"
          dangerouslySetInnerHTML={{ __html: item.name }}
        ></div>
        <div
          className="Speakers_post"
          dangerouslySetInnerHTML={{ __html: item.post }}
        ></div>
      </div>
    </div>
  );
})}
</div>
                          </div>

                        </center>
                      </div>
                 </div>   
                 
        
</div>
            </div>
            <TeamModal
              show={isShow}
              onHide={this.togglePopUp}
              activeItem={this.state.activeItem}
            />
          </div>
        </div>
      </ContentPage>
    );
  }
}

SheShines.propTypes = {
  location: PropTypes.object,
};

export default SheShines;



// WEBPACK FOOTER //
// ./src/pages/IgniteWorkshopOnFinancialModelling/index.js